<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title + ' - ' + namaCompany" :title1="title1" />

        <!-- style="position: relative; for col-md-3" margin-left: 10px; position-fixed -->
        <div class="row ">
          
          <div class="col-md-3 col-12 d-flex flex-column align-items-center position-relative responsive-profile"  >
            <div class=" text-center image-edit-container"  style="position: absolute; z-index: 900;">
               <!-- Hidden file input -->
              <input type="file" id="uploadKTP" ref="foto_ktp" @change="handleUpload" style="display: none" accept="image/*"/>

              <!-- Clickable image label -->

              <img :src="currentEmployee.foto_ktp" class="rounded-circle img-fluid " alt="Profile Photo" 
              style="width: 210px; height: 210px; object-fit: cover; border: 10px solid #F9B233; " @click="triggerUpload">

              <i class='edit-icon bx bxs-pencil'></i>
            </div>
            <div class="card text-white px-3  text-center" style="background-color: #00B680; width: 210px; height: 420px; margin-top: 95px; padding-top: 8rem; position: relative; z-index: 1;">
              <h5 class="fw-bold mb-1 text-white">{{ currentEmployee.nama }}</h5>
              <p v-if="currentEmployee.nama_departemen" class="mb-1 fw-semibold">
                {{ currentEmployee.nama_departemen }}
              </p>
              <p v-if="currentEmployee.nama_jabatan" class="mb-4">
                {{ currentEmployee.nama_jabatan }}
              </p>
              <p v-if="calculateAge(currentEmployee.dob)" class="fw-bold mb-0">
                {{ calculateAge(currentEmployee.dob) }}
              </p>
              <p v-if="currentEmployee.dob" class="mb-0">
                {{ currentEmployee.place_dob ? currentEmployee.place_dob + ', ' : '' }}{{ formatDate(currentEmployee.dob) }}
              </p>
              <p v-if="currentEmployee.telepon" class="mb-4">+{{ currentEmployee.telepon }}</p>

              <!-- kasih v-if klo g null dia muncul   -->
              <div class="" v-if="currentEmployee.terminate_date !== NULL || currentEmployee.terminate_date !== '' ">

                <span class="badge bg-danger" >{{ currentEmployee.terminate_date }}</span> <br/>
                <span class="badge bg-danger">{{  currentEmployee.terminate_reason }}</span>
              </div>

            </div>
          </div>

          <div class="col-md-9 col-12 responsive-detail">

            <div class="menu-tab" >
              <div class="d-flex justify-content-start align-items-center gap-4 order-2 order-md-1 mt-4 mt-md-0">
                <div v-if="!isEditing" class="font-weight-normal text-md position-relative  px-4 py-2" @click="activePage('general_info'); "
                    :class="{ 'menu-top': active_page === 'general_info', 'text-muted': active_page !== 'general_info' }" style="cursor: pointer;">
                    Analysis
                </div>

                <div v-if="!isEditing" class="font-weight-normal text-md position-relative  px-4 py-2" @click="activePage('employement_data');"
                    :class="{ 'menu-top': active_page === 'employement_data', 'text-muted': active_page !== 'employement_data' }" style="cursor: pointer;">
                    DISC
                </div>

                
                <div v-if="!isEditing" class="font-weight-normal text-md position-relative  px-4 py-2" @click="activePage('salary');"
                    :class="{ 'menu-top': active_page === 'salary', 'text-muted': active_page !== 'salary' }" style="cursor: pointer;">
                    KPI
                </div>
                
                
                
                  
                  
              </div>

            </div>

            <!-- /add -->
            <form @submit.prevent="update">
              <div class="card">
                <div class="card-body" >
                
                  <div class="row" :class="{ 'custom-active': active_page !== 'general_info' }">
                    <div class="col-lg-12 mb-3" v-show="active_page == 'general_info'">
                     <div class="row">
                        <div class="col-12 p-3">
                             
                            <div  v-if="currentData.result" v-html="currentData.result"></div>
                            <div class="d-flex justify-content-center align-items-center text-muted pulse" v-else>
                                Please Wait Analyzing...
                                <!-- <div class="spinner-border " role="status"  style="color: #00B680;">
                                    <span class="visually-hidden">Analyzing...</span>
                                </div> -->
                            </div>
                            <!-- <span v-html="currentData.result"></span> -->
                        </div>
                     </div>
                      
                    </div>
                  </div>

                  <div class="row" :class="{ 'custom-active': active_page !== 'employement_data' }">
                    <div class="col-lg-12 mb-3" v-show="active_page == 'employement_data'">
                      -
                      
                    </div>
                  </div>

                  <div class="row" :class="{ 'custom-active': active_page !== 'salary' }">
                    <div class="col-lg-12 mb-3" v-show="active_page == 'salary'">
                      
                      -
                    </div>
                  </div>

                 



                  

                </div>

               

              </div>
                  <!-- /add -->
                <div class="col-lg-12" >
                  
                  <div class="d-flex align-items-center ms-auto">
                    
                    <router-link to="aianalisis" class="btn btn-cancel">Back</router-link>
                  </div>
                </div>
              
                
            </form>

          </div>
        </div>
         
        
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2,  appendForm, timeout, selectedBranch, goPage, rupiahInput } from "@/assets/js/function";
import { RouterLink } from "vue-router";
import { ModelSelect } from "vue-search-select";

export default {
  name: "editemployee",
  components: {
    // Form,
    // Field,
    ModelSelect,
  },
  data() {
    return {
      filter: true,
      title: "JempolKu Analysis",
      title1: "Laporan Hasil Uji ",
      namaCompany: '',
      config: "",
      api: "",
      foto_ktp_img: "",

     

      //data
      currentEmployee: [
        {
          foto_ktp: "",
        }
      ],
      currentDate: new Date,

    //   for return from api openAi
     isLoadingAI: false,
      currentData: [
        {

            result: "",
        }
      ],


      Computers: ["Computers", "Mac"],
      None: ["None", "option1"],
      Tax: ["Choose Tax", "2%"],
      Percentage: ["Percentage", "10%", "20%"],
      Piece: ["Piece", "Kg"],
      Active: ["Active", "Open"],

      // for edit button to change the text to form input
      isEditing: false,

      // for bank list 
      bankList: [],
      isChecking: false,
      checkCountdown: 0, // seconds left
      countdownInterval: null, // interval ID
      rekeningNotFound: false,
      hasCheckedRekening: false, 

      active_page: "general_info",
      isActive: true,
    };
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 30000,
    }

    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;

    localStorage.setItem('actionState', 'update')

    this.namaCompany = localStorage.getItem('namaCompany');
    

    //load employee data
    this.currentEmployee = JSON.parse(localStorage.getItem('currentEmployee'));

    

    
    // //load location
    // const location = JSON.parse(localStorage.getItem('locationList'));
    // location.forEach((value, index) => {
    //   const element = { id: value.id, text: value.nama_lokasi }
    //   this.LocationList.push(element);
    // });
    // //set location
    // if (this.currentEmployee.lokasi_id == 0) {
    //   this.currentEmployee.lokasi_id = location[0].id;
    // }

    // //set date of birth
    // this.currentEmployee.dob = new Date(this.currentEmployee.dob);

    // //set join date 
    // if (this.currentEmployee.join_date != "") {
    //   this.currentEmployee.join_date = new Date(this.currentEmployee.join_date);
    // }

   

    this.dataOpenAi()


  },
  methods: {
    

    activePage(page) {
      this.active_page = page;
      localStorage.setItem("active_page", page)
    },

    replaceHashWithBR(inputString) {
      return inputString.replace(/#/g, '\n');
    },
    formatCurrency(number, index) {
      this.currentEmployee.salary[index].nilai = rupiahInput(number);
    },
    // for bpjs form input 
    formatCurrencyBpjs(name) {
      this.currentEmployee[name] = rupiahInput(this.currentEmployee[name]);
    },

     // for image foto_ktp upload
    triggerUpload() {
      this.$refs.foto_ktp.click();
    },

    handleUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.currentEmployee.foto_ktp = e.target.result; // base64
        };
        reader.readAsDataURL(file);
      }
    },

   

    formatDate(dob) {
      if (!dob) return '';
      const date = new Date(dob);
      if (isNaN(date)) return '';

      const options = { day: '2-digit', month: 'short', year: 'numeric' };
      return date.toLocaleDateString('en-GB', options); // "25 Feb 2025"
    },

    calculateAge(dob) {
      if (!dob) return '';
      const birthDate = new Date(dob);
      if (isNaN(birthDate)) return '';
      
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();

      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      return `${age} Years Old`;
    },

    getNameFileUrl(url) {
      const parts = url.split('/');
      const fileName = parts[parts.length - 1];
      return fileName;
    },

    async dataOpenAi() {
        let formData = new FormData();
        appendForm(formData)


        formData.append('action', 'analyze')
        formData.append('employee_id', this.currentEmployee.id)




      // for (let [key, value] of formData.entries()) {
      //   console.log(`${key}: ${value}`);
      // }
      //   return true

      const api = base_url + '/v3/ai-analystic/index';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;
      
      if(data.status){

        const analitik = data.data.result;
        this.currentData.result = analitik
        
        
      }else {
        
        // console.log("Status is NOT true, or response format unexpected");
     
        AlertPopup2("error", "", data.message, true, 1500);
        
        goPage('aianalisis');
        return;
      }



     


    },
  },

};
</script>

<style scoped>

  .upload-box {
    border: 2px dashed #ccc;
    border-radius: 8px;
    background-color: #f9f9f9;
    width: 200px;
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    margin-left: 1rem;
  }

  .upload-preview {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
  }

  .image-edit-container {
    position: relative;
    display: inline-block;
    cursor: pointer;
  }

  .image-edit-container img {
    transition: 0.3s ease;
  }

  .image-edit-container .edit-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    font-size: 2rem;
    color: white;
    pointer-events: none;
    transition: 0.3s ease;
  }

  .image-edit-container:hover img {
    filter: blur(2px) brightness(0.7);
  }

  .image-edit-container:hover .edit-icon {
    opacity: 1;
  }


  /* for menu tab */

  .menu-top {
    background-color: #09B67D33; /* Adjust opacity and color as needed */
    /* border-bottom: 4px solid #073C69; Primary color (Bootstrap default) */
    color: #09B67D; /* Dark text color (Bootstrap default) */
    font-weight: 500;
    border-radius: 5px 5px 0 0;
  }

  .responsive-detail {
    max-height: 100vh; /* Or any height you want */
    overflow-y: auto;

    /* Hide scrollbar for WebKit browsers */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE 10+ */
  }

  .responsive-detail::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  /* for class invalid no rek */
  .is-invalid {
    border-color: red;
    color: red;
  }


  /* pulse effect */
  .pulse {
    animation: pulseAnim 1.5s infinite;
  }

  @keyframes pulseAnim {
    0% { opacity: 1; }
    50% { opacity: 0.4; }
    100% { opacity: 1; }
  }
  

</style>